/**
 * Custom functionality for Join Us page.
 */

/* global jQuery */

// const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

const positions = require('../components/positions-block');
const inspiration = require('../components/inspiration-block');
const community = require('../components/community-block');
const greenhouse = require('../components/greenhouse-job-board');
const videoPlayer = require('../components/video-player');

exports.init = function() {
	// Join page initialization.  $ is available here...

    // initModule(positions);
	initModule(inspiration);
	initModule(community);
	initModule(videoPlayer);
	
	setTimeout(function() {
		initModule(greenhouse);
	}, 100);
	setTimeout(function() {
		initModule(positions);
	}, 200);
	setTimeout(()=> {
		ScrollTrigger.refresh();
	}, 300);
};

function initModule(mod) {
	// console.log("JOIN: initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}